module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "generated-style",
    attrs: {
      "id": "fm-04-maintoc-epub-text"
    }
  }, [_c('h1', {
    staticClass: "chapter-heading",
    attrs: {
      "id": "toc-anchor",
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_vm._v("what's inside")]), _vm._v(" "), _c('p', {
    staticClass: "toc-recipe",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/FM_05_AllAboutIcePops_text"
    }
  }, [_vm._v("all about ice pops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-recipe",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH01_00_TOC_ePub_image",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("fruity ice pops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-recipe",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH02_00_TOC_ePub_image",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chocolate ice pops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-recipe",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH03_00_TOC_ePub_image",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("creamy ice pops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-recipe",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH04_00_TOC_ePub_image",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("new flavors for ice pops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-recipe",
    attrs: {
      "xml:lang": "en-us",
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/BM_00_CreativeShapes_text",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("creative shapes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b4221d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/FM_04_MainTOC_ePub_text.vue
// module id = 60
// module chunks = 0